import { axiosInstance } from "../../../@core/auth/jwt/jwtService";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const getCouponsById = createAsyncThunk(
  "coupons/getCouponsById",
  async (args, thunkAPI) => {
    const { id, eventId } = args;
    try {
      const response = await axiosInstance.request({
        url: `/events/${eventId}/coupons/${id}`,
        method: "get",
      });
      return { data: response.data };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Error al consultar los cupones. Error: ",
        error.message
      );
    }
  }
);

export const getCoupons = createAsyncThunk(
  "coupons/getCoupons",
  async (args, thunkAPI) => {
    const { pageSize, pageNumber, searchQuery, eventId, orderBy } = args;
    try {
      const response = await axiosInstance.request({
        url: `/events/${eventId}/coupons`,
        method: "get",
        params: { pageSize, pageNumber, searchQuery, orderBy },
      });
      return { data: response };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Error al consultar los cupones. Error: ",
        error.message
      );
    }
  }
);

export const getCouponsSelect = createAsyncThunk(
  "coupons/getCouponsSelect",
  async (args, thunkAPI) => {
    const { pageSize, pageNumber, searchQuery, eventId } = args;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/coupons?fields=id,code,discount`,
      method: "get",
      params: { pageSize, pageNumber, searchQuery },
    });
    return { data: response };
  }
);

export const getCouponsToExport = createAsyncThunk(
  "tickets/getCouponsToExport",
  async (eventId, thunkAPI) => {
    const response = await axiosInstance.request({
      url: `/events/${eventId}/coupons/export`,
      method: "get",
    });
    return { data: response.data };
  }
);

export const createCoupons = createAsyncThunk(
  "coupons/createCoupons",
  async (args, thunkAPI) => {
    const { eventId, data } = args;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/coupons`,
      method: "post",
      data: data,
    });
    return { data: data };
  }
);

export const updateCoupons = createAsyncThunk(
  "coupons/updateCoupons",
  async (args, thunkAPI) => {
    const { id, eventId, data } = args;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/coupons/${id}`,
      method: "patch",
      data,
    });
    return { data: data };
  }
);

export const deleteCoupons = async (id, eventId) => {
  await axiosInstance.delete(`/events/${eventId}/coupons/${id}`, "");
};

export const createCollectionsCoupons = createAsyncThunk(
  "coupons/createCollectionsCoupons",
  async (args, thunkAPI) => {
    const { eventId, data } = args;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/coupons/collection`,
      method: "post",
      data: data,
    });
    return { data: response };
  }
);

export const couponsSlice = createSlice({
  name: "coupons",
  initialState: {
    list: [],
    listId: [],
    coupons: [],
    totalRows: 0,
    pending: false,
    couponsList: [],
    listToExport: [],
    pendingById: false,
    pendingCreate: false,
    pendingUpdate: false,
    pendingExport: false,
    inputSearch: "",
    datecollection: {
      amount: 100,
      available: 1,
      code: "YBVJWIKT",
      discount: 10,
      expiry: "2023-12-20",
      identifier: "Estudiante",
      generationType: "random",
      settings: {
        maximumAmount: 123400,
        maximumQuantity: 123,
        minimumAmount: 12300,
        minimumQuantity: 12,
      },
    },
    listCollection: [],
    couponSelected: "Cupón",
    pendingCollection: false,
    creationSuccess: false,
  },
  reducers: {
    setCreationSuccess: (state, action) => {
      state.creationSuccess = action.payload;
    },
    setListCollection: (state, action) => {
      state.listCollection = action.payload;
    },
    setDataCollection: (state, action) => {
      state.datecollection = action.payload;
      state.creationSuccess = false;
    },
    setCoupons: (state, action) => {
      state.list = action.payload;
    },
    setInputSearch: (state, action) => {
      state.inputSearch = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCoupons.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.list = data;
        state.couponsList = data?.data || [];
        state.loadingStatus = "succeeded";
        state.pending = false;
        const pagination = data?.headers?.["x-pagination"];
        state.totalRows = pagination ? JSON.parse(pagination)?.totalCount : 0;
      })
      .addCase(getCoupons.pending, (state) => {
        state.pending = true;
      })
      .addCase(getCoupons.rejected, (state) => {
        state.loadingStatus = "failed";
        state.pending = false;
      })
      .addCase(getCouponsById.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.listId = data;
        state.pendingById = false;
      })
      .addCase(getCouponsById.pending, (state) => {
        state.pendingById = true;
      })
      .addCase(getCouponsById.rejected, (state) => {
        state.pendingById = true;
      })
      .addCase(getCouponsToExport.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.listToExport = data;
        state.pendingExport = false;
      })
      .addCase(getCouponsToExport.pending, (state) => {
        state.pendingExport = true;
      })
      .addCase(getCouponsToExport.rejected, (state) => {
        state.pendingExport = false;
      })
      .addCase(createCollectionsCoupons.fulfilled, (state, action) => {
        state.pendingCollection = false;
        state.creationSuccess = true;
      })
      .addCase(createCollectionsCoupons.pending, (state) => {
        state.pendingCollection = true;
      })
      .addCase(createCollectionsCoupons.rejected, (state) => {
        state.pendingCollection = true;
      })
      .addCase(getCouponsSelect.fulfilled, (state, action) => {
        const { data } = action.payload;
        const array = [];

        data?.data.forEach((element) => {
          array.push({
            label: `${element.code} - ${element.discount}% de descuento`,
            value: element.id,
          });
        });

        state.coupons = array;
      })
      .addCase(getCouponsSelect.pending, (state) => {
        state.coupons = true;
      })
      .addCase(getCouponsSelect.rejected, (state) => {
        state.coupons = true;
      })
      .addCase(createCoupons.fulfilled, (state, action) => {
        state.couponSelected = {
          label: `${action.payload?.data.code} - ${action.payload?.data.discount}% de descuento`,
          value: action.payload?.data.id,
        };
        state.pendingCreate = false;
      })
      .addCase(createCoupons.pending, (state) => {
        state.pendingCreate = true;
      })
      .addCase(createCoupons.rejected, (state) => {
        state.pendingCreate = false;
      })
      .addCase(updateCoupons.fulfilled, (state, action) => {
        state.pendingUpdate = false;
      })
      .addCase(updateCoupons.pending, (state) => {
        state.pendingUpdate = true;
      })
      .addCase(updateCoupons.rejected, (state) => {
        state.pendingUpdate = false;
      });
  },
});

export const {
  setCoupons,
  setInputSearch,
  setDataCollection,
  setListCollection,
  setCreationSuccess,
} = couponsSlice.actions;

export default couponsSlice.reducer;
